export default __webpack_public_path__ + "static/media/wash-cloth.b280f6a9.svg";